import { render, staticRenderFns } from "./AApplyForm.vue?vue&type=template&id=84850556&"
import script from "./AApplyForm.vue?vue&type=script&lang=js&"
export * from "./AApplyForm.vue?vue&type=script&lang=js&"
import style0 from "./AApplyForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/app/components/Spinner.vue').default})
